module.exports = {
  messages: {
    CN: {
      POVBack: "返回",
      POVOverviewTitle:
        "<strong>\"高级前端工程师 - 北美\"</strong> 已就绪 —— 启动前先看看它将为您带来什么",
      POVOverviewSub:
        "以下是基于您的角色和资料的真实预览。看起来不错？您就可以启动了。",
      POVStep1Title:
        "即将向您输入的 URL 中的 <strong class=\"hl-blue\">240</strong> 位候选人发起联系",
      POVSourceLine:
        "来源 · <strong>您输入的目标受众 LinkedIn 搜索 URL</strong>",
      POVStatusTag: "待触达",
      POVStep1Footnote:
        "<strong>+ 另外 237 位……</strong> 全部来自您输入的 URL。启动后，AI 将与每一位建立联系并沟通。",
      POVStep2Title: "AI 将如何与您的候选人对话",
      POVStep2Note: "（完整示例 · 基于您的资料生成 · 可滚动查看）",
      POVWarnTag: "启动前请审阅 / 调整话术",
      POVStep2Footnote:
        "↑ 这段完整对话根据您的角色 / 公司资料生成。在第 5 步\"对话模拟\"中，您可以测试对话并调整话术（不发起真实触达，不消耗额度）。",
      POVStep3Title: "预期效果",
      POVResultReplyLabel: "预计首批回复",
      POVResultReplyValue: "1–3 天内",
      POVResultInterestLabel: "每月意向候选人",
      POVSafeTip:
        "为保障您的账号安全，连接请求会以<strong>接近真人的节奏分批发送</strong>，因此效果将在 <strong>1–3 天</strong>内陆续呈现。收到第一条回复时我们会立即通知您。",
      POVActionTitle: "如果预览效果不错，您就可以启动了。",
      POVActionSub:
        "启动需要绑定支付方式以激活服务（含免费试用——试用期间不收费）。",
      POVAdjustBtn: "‹ 再调整一下",
      POVConfirmBtn: "确认并启动 →",
      POVLoadingTitle: "正在从您的 URL 获取真实候选人",
      POVLoadingDesc:
        "我们正在读取候选人资料，完成后会自动开始生成真人对话。",
      POVLoadingTimer: "预计剩余约 3 分钟",
      POVLoadingTimerSub: "随任务进度实时更新",
      POVLoadingStep1: "从 URL 获取真实候选人",
      POVLoadingStep1Desc: "正在读取 LinkedIn 搜索结果 · 约 1 分钟",
      POVLoadingStep2: "生成真实候选人对话",
      POVLoadingStep2Desc: "获取完成后自动开始 · 约 2 分钟",
      POVLoadingBadgeIn: "进行中",
      POVLoadingBadgeWait: "等待中",
      POVLoadingNote:
        "您无需停留在本页面。点击“继续”只是跳过等待，后台仍会继续处理。Campaign 上线前，您仍需添加支付方式。",
      POVLoadingSkipBtn: "跳过预览等待并继续",
      POVLoadingCard1Title: "正在从您输入的 URL 获取真实候选人",
      POVLoadingCard1Status: "获取中",
      POVLoadingCard1Msg: "正在读取您的 LinkedIn 搜索链接，请稍候",
      POVLoadingCard1Sub:
        "此处将展示 AI 即将联系的真实候选人，获取完成后将自动展开姓名、职位和地区等信息。",
      POVLoadingCard2Title: "与真实候选人的完整 AI 对话",
      POVLoadingCard2Status: "等待候选人数据",
      POVLoadingCard2Msg: "正在等待真实候选人数据，请稍候",
      POVLoadingCard2Sub:
        "此处将预览与真实候选人的完整 AI 对话，获取完成后自动生成，约需 2 分钟。",
    },
    US: {
      POVBack: "Back",
      POVOverviewTitle:
        "<strong>\"Senior Frontend Engineer - North America\"</strong> is ready — see what it'll deliver before you launch",
      POVOverviewSub:
        "Below is a real preview based on your role and profile. Looks good? You're ready to launch.",
      POVStep1Title:
        "About to reach out to the <strong class=\"hl-blue\">240</strong> candidates from the URL you entered",
      POVSourceLine:
        "Source · <strong>the target-audience LinkedIn search URL you entered</strong>",
      POVStatusTag: "Pending outreach",
      POVStep1Footnote:
        "<strong>+ 237 more ...</strong> all from the URL you entered. After launch, AI will connect and chat with each of them.",
      POVStep2Title: "Here's how AI will talk to your candidates",
      POVStep2Note: "(full example · generated from your profile · scrollable)",
      POVWarnTag: "Review / adjust messaging before launch",
      POVStep2Footnote:
        "↑ This full conversation was generated from your role / company profile. In step 5 \"Conversation Simulation\" you can test-chat and tweak messaging (no real outreach, no quota used).",
      POVStep3Title: "Expected results",
      POVResultReplyLabel: "First replies expected",
      POVResultReplyValue: "within 1–3 days",
      POVResultInterestLabel: "Interested candidates / month",
      POVSafeTip:
        "To keep your account safe, connections are sent <strong>in batches at a human pace</strong>, so results roll in over <strong>1–3 days</strong>. We'll notify you the moment the first reply arrives.",
      POVActionTitle: "If the preview looks good, you're ready to launch.",
      POVActionSub:
        "Launching requires a payment method to activate the service (includes a free trial — no charge during the trial).",
      POVAdjustBtn: "‹ Adjust a bit more",
      POVConfirmBtn: "Confirm & launch →",
      POVLoadingTitle: "Retrieving real candidates from your URL",
      POVLoadingDesc:
        "We're reading candidate profiles. Once complete, we'll automatically start generating a real-person conversation.",
      POVLoadingTimer: "About 3 minutes left",
      POVLoadingTimerSub: "Updates with current task progress",
      POVLoadingStep1: "Retrieve real candidates from URL",
      POVLoadingStep1Desc: "Reading LinkedIn search results · about 1 minute",
      POVLoadingStep2: "Generate a real-candidate conversation",
      POVLoadingStep2Desc: "Starts automatically after retrieval · about 2 minutes",
      POVLoadingBadgeIn: "In progress",
      POVLoadingBadgeWait: "Waiting",
      POVLoadingNote:
        "You don't need to stay on this page. Continuing only skips the wait; background processing continues. You'll still need to add a payment method before the Campaign can launch.",
      POVLoadingSkipBtn: "Skip preview wait and continue",
      POVLoadingCard1Title: "Retrieving real candidates from the URL you entered",
      POVLoadingCard1Status: "Retrieving",
      POVLoadingCard1Msg: "Reading your LinkedIn search URL—please wait",
      POVLoadingCard1Sub:
        "This area will show the real candidates AI is about to contact. Names, roles, and locations will expand automatically when retrieval finishes.",
      POVLoadingCard2Title: "Full AI conversation with a real candidate",
      POVLoadingCard2Status: "Waiting for candidate data",
      POVLoadingCard2Msg: "Waiting for real candidate data—please wait",
      POVLoadingCard2Sub:
        "This area will preview a full AI conversation with a real candidate. Generation starts automatically after retrieval and takes about 2 minutes.",
    },
    AR: {
      POVBack: "رجوع",
      POVOverviewTitle:
        "<strong>\"مهندس واجهات أمامية أول - أمريكا الشمالية\"</strong> جاهز — اطّلع على ما سيقدمه قبل الإطلاق",
      POVOverviewSub:
        "فيما يلي معاينة حقيقية بناءً على دورك وملفك الشخصي. تبدو جيدة؟ أنت جاهز للإطلاق.",
      POVStep1Title:
        "على وشك التواصل مع <strong class=\"hl-blue\">240</strong> مرشحًا من الرابط الذي أدخلته",
      POVSourceLine:
        "المصدر · <strong>رابط بحث LinkedIn للجمهور المستهدف الذي أدخلته</strong>",
      POVStatusTag: "في انتظار التواصل",
      POVStep1Footnote:
        "<strong>+ 237 إضافيًا ...</strong> جميعهم من الرابط الذي أدخلته. بعد الإطلاق، سيتواصل الذكاء الاصطناعي مع كل واحد منهم.",
      POVStep2Title: "إليك كيف سيتحدث الذكاء الاصطناعي مع مرشحيك",
      POVStep2Note: "(مثال كامل · تم إنشاؤه من ملفك الشخصي · قابل للتمرير)",
      POVWarnTag: "راجع / عدّل الرسائل قبل الإطلاق",
      POVStep2Footnote:
        "↑ تم إنشاء هذه المحادثة الكاملة من دورك / ملف شركتك. في الخطوة 5 \"محاكاة المحادثة\" يمكنك إجراء محادثة تجريبية وتعديل الرسائل (بدون تواصل حقيقي وبدون استهلاك الحصة).",
      POVStep3Title: "النتائج المتوقعة",
      POVResultReplyLabel: "أول الردود المتوقعة",
      POVResultReplyValue: "خلال 1–3 أيام",
      POVResultInterestLabel: "المرشحون المهتمون / شهريًا",
      POVSafeTip:
        "للحفاظ على أمان حسابك، يتم إرسال طلبات الاتصال <strong>على دفعات بوتيرة بشرية</strong>، لذلك تظهر النتائج على مدى <strong>1–3 أيام</strong>. سنخطرك فور وصول أول رد.",
      POVActionTitle: "إذا بدت المعاينة جيدة، فأنت جاهز للإطلاق.",
      POVActionSub:
        "يتطلب الإطلاق وسيلة دفع لتفعيل الخدمة (يشمل تجربة مجانية — بدون رسوم خلال التجربة).",
      POVAdjustBtn: "‹ تعديل إضافي بسيط",
      POVConfirmBtn: "تأكيد وإطلاق →",
      POVLoadingTitle: "جارٍ استرداد المرشحين الحقيقيين من الرابط الذي أدخلته",
      POVLoadingDesc:
        "نقرأ ملفات المرشحين الآن، وبعد الانتهاء سنبدأ تلقائيًا في توليد محادثة مع شخص حقيقي.",
      POVLoadingTimer: "متبقٍ حوالي 3 دقائق",
      POVLoadingTimerSub: "يتحدث مع تقدم المهمة الحالية",
      POVLoadingStep1: "استرداد المرشحين الحقيقيين من الرابط",
      POVLoadingStep1Desc: "جارٍ قراءة نتائج بحث LinkedIn · حوالي دقيقة واحدة",
      POVLoadingStep2: "توليد محادثة مع مرشح حقيقي",
      POVLoadingStep2Desc: "تبدأ تلقائيًا بعد الاسترداد · حوالي دقيقتين",
      POVLoadingBadgeIn: "قيد التنفيذ",
      POVLoadingBadgeWait: "قيد الانتظار",
      POVLoadingNote:
        "لا تحتاج إلى البقاء في هذه الصفحة. المتابعة تتخطى الانتظار فقط، وتستمر المعالجة في الخلفية. ستحتاج أيضًا إلى إضافة وسيلة دفع قبل إطلاق الحملة.",
      POVLoadingSkipBtn: "تخطي انتظار المعاينة والمتابعة",
      POVLoadingCard1Title: "جارٍ استرداد المرشحين الحقيقيين من الرابط الذي أدخلته",
      POVLoadingCard1Status: "جارٍ الاسترداد",
      POVLoadingCard1Msg: "جارٍ قراءة رابط بحث LinkedIn الخاص بك — يرجى الانتظار",
      POVLoadingCard1Sub:
        "سيعرض هذا القسم المرشحين الحقيقيين الذين سيتواصل معهم الذكاء الاصطناعي. ستظهر الأسماء والأدوار والمواقع تلقائيًا بعد اكتمال الاسترداد.",
      POVLoadingCard2Title: "محادثة AI كاملة مع مرشح حقيقي",
      POVLoadingCard2Status: "في انتظار بيانات المرشح",
      POVLoadingCard2Msg: "في انتظار بيانات المرشح الحقيقي — يرجى الانتظار",
      POVLoadingCard2Sub:
        "سيعرض هذا القسم معاينة لمحادثة AI كاملة مع مرشح حقيقي. يبدأ التوليد تلقائيًا بعد الاسترداد ويستغرق حوالي دقيقتين.",
    },
  },
};
